import React from 'react'
import ResturansFoodContainer from '../../../../Components/ProductRegisterPart/ResturansFoodContainer/ResturansFoodContainer'
import Layout from '../../Layout'

const ResturansFood = () => {
  return (
    <Layout><ResturansFoodContainer/></Layout>
  )
}

export default ResturansFood